import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "banner__content" }
const _hoisted_2 = { class: "banner__content banner__content-white" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "banner__bg" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "banner",
    class: _normalizeClass(["banner", {'banner banner-none': _ctx.state.isOpen }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["banner__container", {'banner__container banner__container-none': _ctx.state.isOpen }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.state.title), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.state.results), 1)
      ])
    ], 2),
    _hoisted_3
  ], 2))
}